<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">นับสต๊อก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3" v-if="counting_check == 2">
            <v-btn type="button" class="btn_add_data" elevation="2" @click="link('/arin/pos/countingstockcreate')"
              large>สร้างรอบนับ</v-btn>
          </div>

          <!-- ต้องทำการ if else ดักต่อเมื่อสร้างรอบนับแล้ว -->
          <div class="title_page ma-3" v-else>
            <v-btn type="button" class="btn_detail_data" elevation="2" @click="link('/arin/pos/countingstockcount')"
              large>นับสต๊อก</v-btn>
          </div>

        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6" class="content-header-title">
                <div class="">ประวัติการนับสต๊อก</div>
              </v-col>
              <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                <div class="mt-1">
                  <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                    required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3" v-if="page_number == 1">
            <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props"
              mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div class="font-16">{{ dataDetail.item.round_name }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.count_date }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.note }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.user_name }}</div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span>
                        <v-btn v-if="dataDetail.item.count_status == 1" elevation="4" class="ma-3 font-16" outlined
                          color="#88B358" title="ตรวจสอบการนับสต๊อก" style="border-radius:10px"
                          @click="link('/arin/pos/countingstockcheck?id='+dataDetail.item.id)">
                          <v-icon>mdi-checkbox-marked-circle</v-icon> ตรวจสอบการนับสต๊อก
                        </v-btn>
                      </span>
                      <span v-if="dataDetail.item.count_status == 2">
                        <v-btn elevation="4" class="ma-3 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                          style="border-radius:10px" @click="link('/arin/pos/countingstockdetail/' + dataDetail.item.id)">
                          <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                        </v-btn>
                      </span>

                      <!-- @click="edit_count_lot(dataDetail.item.id)" -->
                      <span v-if="dataDetail.item.count_status == 0">
                        <v-btn elevation="4" class="ma-3 font-16 " outlined color="#FEA06C" title="แก้ไขรอบนับ"
                          style="border-radius:10px" @click="link('/arin/pos/countingstockedit/' + dataDetail.item.id)">
                          <v-icon>mdi-pencil</v-icon> แก้ไขรอบนับ
                        </v-btn>
                      </span>
                      <span v-if="dataDetail.item.count_status == 0">
                        <v-btn elevation="4" class="ma-3 font-16 " outlined color="#B0886B" title="ปิดรอบ"
                          style="border-radius:10px" @click="dialog_cancel_order_dialog(dataDetail.item.id)">
                          <v-icon>mdi-lock-clock</v-icon> ปิดรอบ
                        </v-btn>
                      </span>

                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </section>
          <section class="pa-3" v-if="page_number == 2">
            <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
              <template>
                <v-form ref="setting">
                  <v-timeline align-top dense>
                    <v-timeline-item fill-dot color="#D6BFAF">
                      <template v-slot:icon>
                        <div class="logo_timeline mx-auto my-auto">
                          <img src="@/assets/arin_assets/box.png">
                        </div>
                      </template>
                      <div class="d-flex" style="margin-top: 2px">
                        <div class="header-content py-1 pl-5 pr-3 text-center">
                          <div class="content-font">ข้อมูลสมาชิก</div>
                        </div>
                      </div>
                      <section>
                        <div class="text_title d-flex justify-space-between mt-3">
                          <div>รอบนับครั้งที่ 00001</div>
                          <div>ผู้สร้างรอบนับ : Arin Admin</div>
                        </div>
                        <div class="input_four_six">
                          <section class="pa-2">
                            <div class="text_title mt-2">วันที่นับสต๊อก <span class="red--text">*</span></div>
                            <div class="mt-2">
                              <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field color="#86bc3a" v-model="date" label="วันที่ (วัน/เดือน/ปี)"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                    outlined></v-text-field>
                                </template>
                                <v-date-picker color="#86bc3a" @change="diffDateTH(dateEN)"
                                  v-model="dateEN"></v-date-picker>
                              </v-menu>
                            </div>
                          </section>
                          <section class="pa-2">
                            <div class="text_title mt-2">ผู้นับนับสต๊อก <span class="red--text">*</span></div>
                            <div class="mt-2">
                              <v-autocomplete color="#D6BFAF" class="input-radius" :items="money_list" item-text="name"
                                item-value="id" :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']" hide-details="auto"
                                placeholder="กรุณาเลือกประเภทบัญชี" multiple required outlined></v-autocomplete>
                            </div>
                          </section>
                        </div>
                        <div>
                          <section class="pa-2">
                            <div class="text_title mt-2">หมายเหตุ</div>
                            <div class="mt-2">
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" required
                                placeholder="กรุณากรอกหมายเหตุ" outlined></v-text-field>
                            </div>
                          </section>
                        </div>
                      </section>
                    </v-timeline-item>
                  </v-timeline>
                  <div class="text-center mt-6 mb-3">
                    <v-btn type="submit" height="45" class="white--text grad-success-arin-bg mobile_btn"
                      style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
                  </div>
                </v-form>
              </template>
            </v-card>
          </section>
          <section class="pa-3" v-if="page_number == 3">
            <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
              <template>
                <v-form ref="setting">
                  <v-timeline align-top dense>
                    <v-timeline-item fill-dot color="#D6BFAF">
                      <template v-slot:icon>
                        <div class="logo_timeline mx-auto my-auto">
                          <img src="@/assets/arin_assets/box.png">
                        </div>
                      </template>
                      <div class="d-flex" style="margin-top: 2px">
                        <div class="header-content py-1 pl-5 pr-3 text-center">
                          <div class="content-font">ข้อมูลสมาชิก</div>
                        </div>
                      </div>
                      <section>
                        <div class="text_header mt-3">
                          ค้นหาสินค้า
                        </div>
                        <div>
                          <section class="pa-2">
                            <div class="text_title mt-2">เลขบาร์โค้ด / ชื่อสินค้า <span class="red--text">*</span></div>
                            <div class="mt-2">
                              <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-qrcode-scan"
                                hide-details="auto" required placeholder="กรุณากรอกเลขบาร์โค้ด" outlined></v-text-field>
                            </div>
                          </section>
                        </div>
                        <div class="text_header mt-3">
                          ข้อมูลสินค้า
                        </div>
                        <div>
                          <section class="pa-2">
                            <div class="input_two_four">
                              <div class="mr-3">
                                <v-img class="preview" height="200" max-width="300"
                                  lazy-src="@/assets/arin_assets/image_sun_color.png"
                                  src="@/assets/arin_assets/image_sun_color.png"></v-img>
                              </div>
                              <div class="ml-3 d-flex flex-column justify-center">
                                <div class="text_header_title">ชื่อสินค้า</div>
                                <div class="text_title mt-2">เลขบาร์โค้ด / ชื่อสินค้า <span class="red--text">*</span>
                                </div>
                                <div class="mt-2">
                                  <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" required
                                    placeholder="กรุณากรอกจำนวนที่นับได้" outlined></v-text-field>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </section>
                    </v-timeline-item>
                  </v-timeline>
                  <div class="text-center mt-6 mb-3">
                    <v-btn type="submit" height="45" class="white--text grad-success-arin-bg mobile_btn"
                      style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
                  </div>
                </v-form>
              </template>
            </v-card>
          </section>

          <!-- Artel แจ้งเตือนเสร็จสิ้น -->
          <v-dialog v-model="dialog_cancel_order" persistent max-width="400">
            <v-card class="input-radius">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ยืนยันการปิดรอบนับสต๊อก</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="dialog_cancel_order = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-img width="100" height="100" :lazy-src="img_cancel_order" :src="img_cancel_order"
                      class="preview mt-3 mb-2"></v-img>
                    <h3>คุณต้องการปิดรอบนับสต๊อกหรือไม่</h3>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn type="button" @click="cancel_counting_stock();" class="btn_add_data_pop" elevation="4"
                  large>ยืนยัน</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import cancel_order from "@/assets/checked_refund.png";
import { minDate } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Admin_list",
  data() {
    return {
      loading_page: false,
      img_cancel_order: cancel_order,
      dialog_cancel_order: false,
      data_cancel: '',
      page_number: 1,
      search: '',
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'รอบนับ',
          value: 'round_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่นับสต๊อก',
          value: 'count_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ผู้สร้างรอบนับ',
          value: 'user_name',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '200px',
        },
      ],
      data_list: [],
      counting_check: null,
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'นับสต๊อก',
          disabled: false,
          href: '#',
        },
      ],
      menu_date: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateEN: '',
      start_date: this.min_date(),
      money_list: [
        { id: 1, name: 'Stock' },
        { id: 2, name: 'Stock2' },
      ],
    }
  },
  methods: {
    dialog_cancel_order_dialog(id) {
      this.dialog_cancel_order = true;
      this.data_cancel = id;
    },
    cancel_counting_stock() {
      // count_status
      let send_data = {
        id: this.data_cancel,
        count_status: 1,
      }
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      HTTP_ARIN.post('/countstock/store/update/status', send_data, config)
        .then((res) => {
          if (res.data.successful === true) {
            let timerInterval
            Swal.fire({
              title: 'เสร็จสิ้น',
              text: 'แก้ไขข้อมูลเรียบร้อย',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => { }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
                setTimeout(function () {
                  window.location.reload();
                });
              }
            })
          }
          else {
            Swal.fire({
              title: 'แจ้งเตือน',
              text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
    },
    link(link) {
      window.location.href = link;
    },
    edit_employee() {
      this.$router.push('/arin/adminlist/editemployee')
    },
    detail_employee() {
      this.$router.push('/arin/adminlist/detailemployee')
    },
    async page(type) {
      // this.loading_page = true
      this.page_number = type
    },
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '/' + month + '/' + year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    getCountingList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/countstock/store/', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.data_list = res.data.data;
          this.counting_check = res.data.last_round;
        }
      })
    },
  },
  created() {
    const diff = this.date.split('-')
    const day = diff[2]
    const month = diff[1]
    const year = parseInt(diff[0]) + 543
    const final_date = day + '/' + month + '/' + year
    return this.date = final_date
  },
  mounted() {
    this.getCountingList();
  }
}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */
.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.radio_half {
  display: grid;
  grid-template-columns: 50%;
}

.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
  display: inline-block;
}

.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.text_header {
  color: #616A6B;
  font-weight: bold;
  font-size: 20px;
}

.text_header_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
  font-size: 16px !important;
}


.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.input_two_four {
  display: grid;
  grid-template-columns: 20% 40%;
}

.input_four_six {
  display: grid;
  grid-template-columns: 40% 60%;
}

.content-header-title {
  color: #616A6B;
  font-weight: 1000;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.btn_detail_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #0F71B9 0%, rgba(136, 179, 88, 0) 100%), #8EBBDC !important;
  border-radius: 10px;
  width: 100%;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 100% !important;
}

.btn_add_data_pop {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 135px !important;
}
</style>
